module.exports = __webpack_public_path__ + "static/img/10-4.81624e79.jpg";